import { IXsollaActivationStatusResponse } from '../../../../../shared/common/purchases';
import { apiServiceAsync } from './apiService';

export type TXsollaActivationStatusParams = {
  attemptRecovery?: boolean;
};

export class XsollaAuthenticationRequiredError extends Error {
  constructor(message = 'Authentication required') {
    super(message);
    this.name = 'XsollaAuthenticationRequiredError';
  }
}

function getErrorStatusCode(error: any): number | undefined {
  return error?.statusCode || error?.status || error?.response?.statusCode || error?.response?.status;
}

export function isXsollaAuthenticationError(error: unknown): boolean {
  if (error instanceof XsollaAuthenticationRequiredError) {
    return true;
  }

  const statusCode = getErrorStatusCode(error as any);
  if (statusCode === 401) {
    return true;
  }

  return error instanceof Error && error.message === 'Authentication required';
}

export const xsollaCheckoutClient = {
  getActivationStatus(
    params: TXsollaActivationStatusParams = {}
  ): Promise<IXsollaActivationStatusResponse> {
    return apiServiceAsync.getXsollaActivationStatus(params)
      .then((result) => {
        if (result.status === 'error' && !result.hasActiveSubscription) {
          throw new Error(result.message || 'Xsolla activation recovery failed');
        }

        return result;
      })
      .catch((error: unknown) => {
        if (isXsollaAuthenticationError(error)) {
          throw new XsollaAuthenticationRequiredError();
        }

        throw error;
      });
  }
};
